module.exports = __webpack_public_path__ + "static/bluedressing-b11405e30daf9a8fbe169ef6a0cc6ba1.png";